import {
  AsyncPipe,
  DatePipe,
  I18nPluralPipe,
  NgClass,
  NgFor,
  NgIf,
  NgTemplateOutlet,
  SlicePipe,
} from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import {
  ModalComponent,
  RestoreScrollPositionDirective,
  SdvorButtonComponent,
  SdvorCustomPaginationComponent,
  SdvorRadioComponent,
} from '@sdvor/shared/ui';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { UrlModule } from '@spartacus/core';
import { IconModule, MediaModule, SpinnerComponent } from '@spartacus/storefront';
import { QRCodeComponent } from 'angularx-qrcode';
import { OrderDownloadBillComponent, OrderListItemComponent, OrderStatusLabelComponent } from '../../../components';
import { NoOrdersBlockComponent } from '../../../components/no-orders-block/no-orders-block';
import { OnlineOrdersFilterComponent } from './online-orders-filter/online-orders-filter.component';
import { OnlineOrdersListComponent } from './online-orders-list.component';
import { SdOrderHistoryItemsListComponent } from './order-history-items-list/order-history-items-list.component';

@NgModule({
  declarations: [SdOrderHistoryItemsListComponent, OnlineOrdersListComponent],
  exports: [OnlineOrdersListComponent],
  imports: [
    NgFor,
    NgIf,
    NgClass,
    I18nPluralPipe,
    AsyncPipe,
    RouterLink,
    SlicePipe,
    RestoreScrollPositionDirective,
    DatePipe,
    IconModule,
    SdvorButtonComponent,
    OrderStatusLabelComponent,
    SdvorCustomPaginationComponent,
    MediaModule,
    UrlModule,
    SpinnerComponent,
    ReactiveFormsModule,
    SdvorRadioComponent,
    OrderDownloadBillComponent,
    ModalComponent,
    QRCodeComponent,
    NgTemplateOutlet,
    SdvorIconComponent,
    NoOrdersBlockComponent,
    OnlineOrdersFilterComponent,
    OrderListItemComponent,
  ],
})
export class OnlineOrdersListModule {}
